import React from 'react'
import Icon from '../../misc/icon'
import { IconNameType } from '../../misc/icon/types'

interface Props {
    /** Function to handle the sorts change */
    handleSortChange?: (s: string) => void
    /** Configuration for the column to render */
    header: string | { key: string; label?: string }
    /** Grid sorting values */
    sorts?: { [key: string]: number | undefined }
}

/**
 * Component to render the grid header cell
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const CellHeaderRender: React.FC<Props> = ({ header, handleSortChange, sorts }) => {
    let content = ''
    let key = ''
    // If the header config its an object we want
    if (typeof header === 'object') {
        content = header.label ? header.label : header.key
        key = header.key
    } else {
        content = header
        key = header
    }
    const sortValue = sorts ? sorts[key] : undefined
    const hasSort = sortValue !== undefined
    let sortIconName: IconNameType = 'sort'
    if (sortValue === 1) {
        sortIconName = 'sort-up'
    } else if (sortValue === -1) {
        sortIconName = 'sort-down'
    }

    const onChangeSort = () => {
        if (handleSortChange && hasSort) {
            handleSortChange(key)
        }
    }

    return (
        <th className={`table-thead-cell ${hasSort ? 'hover' : ''}`} onClick={onChangeSort}>
            <div className="flex flex-row flex-1 items-center">
                <span className="flex flex-1">{content}</span>
                {hasSort && (
                    <Icon
                        type={sortIconName}
                        size="lg"
                        className={sortValue === 0 ? 'opacity-05' : ''}
                    />
                )}
            </div>
        </th>
    )
}

export default CellHeaderRender
